import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import Protected from '../Common/Protected';
import { useEffect } from 'react';

const FullscreenLayoutWithoutFooter = ({ children }) => {
  const theme = useTheme();
  useEffect(() => {
    const preloader = document.querySelector('#preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.remove();
      }, 300);
    }
  }, []);
  return (
    <Protected>
      <Box
        sx={{
          flex: 1,
          height: '100%',

          '.MuiPageTitle-wrapper': {
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05
                  )}`
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flexGrow: 1,
            minHeight: '90vh'
          }}
        >
          <Box display="block">{children || <Outlet />}</Box>
        </Box>
      </Box>
    </Protected>
  );
};

FullscreenLayoutWithoutFooter.propTypes = {
  children: PropTypes.node
};

export default FullscreenLayoutWithoutFooter;
